import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import CreateAccount from '../auth/createAccount';
import LoginAccount from '../auth/loginAccount';
import { CDN_BASE_URL } from '../../constants';
import ForgotPassword from '../auth/forgotPassword';
import Logo from '../../assets/Logo.svg';
import AnimatedTapeAuth from './AnimatedTapeAuth';
import { useGrowthBookValues } from '../../contexts/GrowthBookContext';
import { trackRegistrationModalOpened } from '../../utils/analytics';

// Placeholder auth-screen background — to be replaced with a trans-specific
// hero video/poster once assets land.
const AUTH_VIDEO = `${CDN_BASE_URL}/Realistic/auth_realistic.mp4`;
const AUTH_POSTER = `${CDN_BASE_URL}/Realistic/first_frame_realistic.jpg`;

const AuthModal = ({ isOpen, onClose }) => {
  const [authView, setAuthView] = useState('signup');
  const { magicLink } = useGrowthBookValues();
  const isMagicLink = magicLink === 'ON';

  console.log('[AuthModal] createaitrans-magicLink =', magicLink, '→ isMagicLink =', isMagicLink);

  // Registration form opened → GTM funnel event.
  useEffect(() => {
    if (isOpen) {
      trackRegistrationModalOpened();
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className={`auth-modal-overlay${isMagicLink ? ' magic-link' : ''}`}>
      <div className="video-bg">
        <video
          src={AUTH_VIDEO}
          poster={AUTH_POSTER}
          autoPlay
          muted
          loop
          playsInline
          className="auth-bg-video"
        />
      </div>
      <div className="logo">
        <img src={Logo} alt="" />
      </div>
      <div className="auth-modal">
        <div className="auth-modal-content">
          <AnimatedTapeAuth />
          <div className="auth-form-container">
            {isMagicLink ? (
              <CreateAccount onClose={onClose} />
            ) : (
              <>
                {authView === 'login' && (
                  <LoginAccount
                    onSwitchToSignup={() => setAuthView('signup')}
                    onSwitchToForgot={() => setAuthView('forgot')}
                  />
                )}
                {authView === 'signup' && (
                  <CreateAccount onContinue={() => setAuthView('login')} />
                )}
                {authView === 'forgot' && (
                  <ForgotPassword onBackToLogin={() => setAuthView('login')} />
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

AuthModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  selectedStyle: PropTypes.string,
};

export default AuthModal;
